<div>
    <ng-template anomalyGrid></ng-template>
</div>